import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { caricaVariabili } from "app/services/VariabiliStrutture/VariabiliStrutture";
import { salva } from "../ServiceController";
import { caricaOpzioniProtette, salvaOpzioniProtette } from "./opzioniService";

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.message || error?.response?.data?.Message || fallback;

const OpzioniForm = ({ accessToken, onCancel, onSaved }) => {
  const dispatch = useDispatch();
  const [variabili, setVariabili] = useState([]);
  const [localInputValues, setLocalInputValues] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);
    setError("");
    const request = accessToken ? caricaOpzioniProtette(accessToken) : caricaVariabili();

    dispatch(request)
      .then((data) => {
        if (!isMounted) return;
        const elenco = Array.isArray(data) ? data : [];
        setVariabili(elenco);
        setLocalInputValues(elenco.reduce((acc, { chiave, valore }) => {
          acc[chiave] = valore ?? "";
          return acc;
        }, {}));
      })
      .catch((requestError) => {
        if (isMounted) setError(getErrorMessage(requestError, "Impossibile caricare le opzioni."));
      })
      .finally(() => {
        if (isMounted) setIsLoading(false);
      });

    return () => { isMounted = false; };
  }, [accessToken, dispatch]);

  const handleInputChange = useCallback((event, chiave) => {
    const value = event.target.value;
    setLocalInputValues((currentValues) => ({ ...currentValues, [chiave]: value }));
    setSuccess("");
  }, []);

  const handleSave = useCallback(async () => {
    setIsSaving(true);
    setError("");
    setSuccess("");
    const updatedVariabili = variabili.map(({ id, chiave }) => ({
      id,
      chiave,
      valore: localInputValues[chiave] ?? "",
    }));

    try {
      if (accessToken) {
        await dispatch(salvaOpzioniProtette(updatedVariabili, accessToken));
      } else {
        await dispatch(salva("VariabiliStrutture/SalvaMulti", updatedVariabili));
      }
      setSuccess("Opzioni salvate correttamente.");
      if (onSaved) onSaved();
    } catch (saveError) {
      const unauthorized = [401, 403].includes(saveError?.response?.status);
      setError(getErrorMessage(saveError, unauthorized
        ? "L'autorizzazione è scaduta. Chiudi la finestra e inserisci nuovamente la password."
        : "Impossibile salvare le opzioni."));
    } finally {
      setIsSaving(false);
    }
  }, [accessToken, dispatch, localInputValues, onSaved, variabili]);

  if (isLoading) return <div className="text-center py-5">Caricamento opzioni...</div>;

  return (
    <div>
      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}
      {!error && variabili.length === 0 && (
        <div className="alert alert-info">Non sono presenti opzioni configurabili.</div>
      )}
      <div className="table-responsive">
        <table className="table table-sm table-borderless align-middle mb-0">
          <tbody>
            {variabili.map(({ id, chiave }, index) => (
              <tr key={`${id}-${index}`}>
                <td style={{ minWidth: 220 }}>
                  <label className="mb-0" htmlFor={`opzione-${id}-${index}`}><b>{chiave}</b></label>
                </td>
                <td style={{ minWidth: 300 }}>
                  <input
                    type="text"
                    className="form-control mb-2"
                    id={`opzione-${id}-${index}`}
                    value={localInputValues[chiave] ?? ""}
                    onChange={(event) => handleInputChange(event, chiave)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-end gap-2 mt-3">
        {onCancel && (
          <button type="button" onClick={onCancel} className="btn btn-outline-secondary" disabled={isSaving}>Annulla</button>
        )}
        <button
          type="button"
          onClick={handleSave}
          className="btn btn-primary"
          disabled={isSaving || variabili.length === 0 || Boolean(error)}
        >
          {isSaving ? "Salvataggio..." : "Salva"}
        </button>
      </div>
    </div>
  );
};

export default OpzioniForm;
